import React, { useEffect, useRef, useState } from "react";

const NaverMap = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [mapError, setMapError] = useState(false);

  useEffect(() => {
    if (!window.naver || !mapRef.current || mapInstanceRef.current) {
      if (!window.naver) {
        // 네이버 맵이 아직 로드되지 않았다면 3초 정도 기다렸다가 시도
        const retryTimeout = setTimeout(() => {
          if (!window.naver || !window.naver.maps) {
            console.error("Naver Map 로딩 실패");
            setMapError(true);
          }
        }, 3000);

        return () => clearTimeout(retryTimeout);
      }
      return;
    }

    try {
      const mapOptions = {
        center: new window.naver.maps.LatLng(35.037354, 126.906298),
        zoom: 15,
      };

      const map = new window.naver.maps.Map(mapRef.current, mapOptions);

      new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(35.037354, 126.906298),
        map,
        title: "반딧불 캔들 카페",
      });

      mapInstanceRef.current = map;
    } catch (error) {
      console.error("지도 초기화 에러:", error);
      setMapError(true);
    }
  }, []);

  if (mapError) {
    return <p className="text-sm text-gray-500">※ 현재 지도를 불러올 수 없습니다.</p>;
  }

  return (
    <div
      ref={mapRef}
      style={{
        width: "100%",
        height: "100%", // 이 부분이 중요
        minHeight: "400px", // 최소 높이 확보
        borderRadius: "12px",
        overflow: "hidden",
      }}
    />
  );
};

export default NaverMap;
